var $bf90a11a7a42a0f7$exports = {};
$bf90a11a7a42a0f7$exports = {
  "colorPicker": "Color picker",
  "twoDimensionalSlider": "2D slider",
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorSwatch": "color swatch",
  "transparent": "transparent"
};
export { $bf90a11a7a42a0f7$exports as default };